/** Twilio Conversations identity 里常见的 URL 编码风格字符还原 */
export const decodeTwilioIdentity = (identity: string) =>
    identity.replace(/_40/g, "@").replace(/_2E/gi, ".").replace(/_2D/gi, "-");

/** 坐席展示名：优先友好名，邮箱则取 @ 前一段，避免展示完整邮箱 */
export const resolveAgentDisplayName = (author?: string, friendlyName?: string) => {
    const name = (friendlyName || "").trim();
    if (name && !name.includes("@") && name !== "系统" && name.toLowerCase() !== "system") {
        return name;
    }
    if (!author) {
        return "坐席";
    }
    const decoded = decodeTwilioIdentity(author);
    if (decoded.includes("@")) {
        return decoded.split("@")[0] || "坐席";
    }
    return decoded || "坐席";
};

export type HistoryParticipantInfo = {
    identity: string;
    type: "customer" | "agent";
    email?: string;
    friendlyName?: string;
};

export const formatHistoryAuthorLabel = (
    author?: string,
    conversationSid?: string,
    options?: {
        customerEmail?: string;
        participants?: HistoryParticipantInfo[];
        agentFriendlyName?: string;
    }
) => {
    if (!author) {
        return "未知";
    }
    if (conversationSid && author === conversationSid) {
        return "因美纳";
    }
    if (author === "Concierge") {
        return "因美纳";
    }

    const participants = options?.participants;
    if (author.startsWith("FX")) {
        const customer = participants?.find((p) => p.type === "customer" && p.identity === author);
        if (customer?.email) {
            return customer.email;
        }
        if (options?.customerEmail) {
            return options.customerEmail;
        }
        const decoded = decodeTwilioIdentity(author);
        return decoded.includes("@") ? decoded : "客人";
    }

    const agent = participants?.find((p) => p.identity === author);
    return `坐席 (${resolveAgentDisplayName(author, options?.agentFriendlyName || agent?.friendlyName)})`;
};
